module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot01_beach-photo-4f947f6e9f4a34ef61ab652df55a649d.jpg";